import React from "react";
import type { ReactNode } from "react";
import { Radio as RadioAria } from "react-aria-components";
import type { RadioProps } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

import { IndexedOptionContent } from "./IndexedOptionContent";

type RadioCardProps = {
  index: string;
  label: ReactNode;
} & Omit<RadioProps, "children">;

export function IndexedOption({ className, index, label, ...radioProps }: RadioCardProps) {
  return (
    <RadioAria className={cn(indexedOptionStyles, className)} {...radioProps}>
      {({ isSelected }) => (
        <IndexedOptionContent index={index} isSelected={isSelected} label={label} />
      )}
    </RadioAria>
  );
}

export const indexedOptionStyles = cn(
  // Base styles
  "tw:flex! tw:cursor-pointer tw:items-baseline tw:gap-3 tw:mb-0!",
  "tw:rounded-lg tw:border tw:p-2",

  // Default state
  "tw:border-stroke-quaternary tw:bg-fill-white",

  // Selected state
  "tw:selected:border-stroke-teal-primary tw:selected:bg-fill-teal-quinary tw:selected:shadow-[0_0_0_1px_var(--tw-color-stroke-teal-primary)]",

  // Hover state
  "tw:hover:border-stroke-teal-primary",

  // Focus state
  "tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2",
  "tw:focus-visible:outline-stroke-bright-purple-secondary",

  // Disabled state
  "tw:disabled:opacity-50 tw:disabled:cursor-not-allowed",
);
